import React from "react";
import ReactDOM from "react-dom";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FlagProvider } from '@unleash/proxy-client-react';
import "./index.css";
import App from "./App";
import { Spinner } from "./assets/spinner";

const config = {
    url: 'https://edge.webtonicadmin.co.za/api/frontend', // Your front-end API URL or the Unleash proxy's URL (https://<proxy-url>/proxy)
    clientKey: 'default:production.0bbd3c3faa19f1cb365d15bcb0ef730aabae70431438e0fd8d431674', // A client-side API token OR one of your proxy's designated client keys (previously known as proxy secrets)
    refreshInterval: 120, // How often (in seconds) the client should poll the proxy for updates
    appName: 'default', // The name of your application. It's only used for identifying your application
}

ReactDOM.render(
  <React.StrictMode>
      <FlagProvider config={config}>
          <App/>
      </FlagProvider>
    <Spinner />
  </React.StrictMode>,
  document.getElementById("root")
);